import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { CommentFilterService } from './comment-filter.service';

export const ngxCommentFilterServiceModule = angular.module('ngxCommentFilterServiceModule', [])
	.factory('ngxCommentFilterService', downgradeInjectable(CommentFilterService) as any)
	.name;
